import React, { ReactNode } from 'react';
import AppConfirmationModal from '@nxsys/components/AppConfirmationModal';
import {
  IconContainer,
  WrapperIconByType,
} from '@nxsys/components/AppConfirmationModal/index.styled';
import { AppIconType, Icons } from '@nxsys/types/icons';
import { useTheme } from 'styled-components';

interface AppConfirmationModalWithIconProps {
  open: boolean;
  title?: string;
  paragraph?: string | ReactNode;
  okText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onDeny: () => void;
  type: 'warning' | 'success' | 'error';
  icon: AppIconType;
  loading?: boolean;
  showFooterButton?: boolean;
}

const AppConfirmationModalWithIcon: React.FC<
  AppConfirmationModalWithIconProps
> = ({
  open,
  title,
  paragraph,
  okText,
  cancelText,
  onConfirm,
  onDeny,
  type,
  icon,
  loading,
  showFooterButton = true,
}) => {
  const Icon = Icons[icon];
  const theme = useTheme();
  const iconColor =
    type === 'warning'
      ? theme.palette.orange[700]
      : type === 'success'
        ? theme.palette.green[500]
        : theme.palette.red[500];

  return (
    <AppConfirmationModal
      icon={
        <IconContainer type={type}>
          <WrapperIconByType type={type}>
            <Icon color={iconColor} />
          </WrapperIconByType>
        </IconContainer>
      }
      title={title}
      paragraph={paragraph}
      okText={okText}
      cancelText={cancelText}
      open={open}
      onConfirm={onConfirm}
      onDeny={onDeny}
      loading={loading}
      showFooterButton={showFooterButton}
    />
  );
};

export default AppConfirmationModalWithIcon;
